import React from "react";
import S from './AccreditationPage.module.scss';

export const AccreditationPage = () => {
    return (
        <div className={S.root}>
            <div className={S.elements}>
                <h1>ИТ-аккредитация</h1>
                <div className={S.boxText}>
                    <div className={S.companyName}>ООО «БМК-СОФТ»</div>
                    <div className={S.boxElements}>
                        <div className={S.boxInfo}>
                            <div>ИНН: 4400022528</div>
                            <div>ОКВЭД: 62.01 «Разработка компьютерного программного обеспечения»</div>
                            <div>Юр. Адрес: 156000, г. Кострома, ул. Смоленская, д. 12, кв. 3</div>
                            <div>Телефон: <a href="tel:+74942419311">+7 (4942) 41-93-11</a></div>
                            <div>Электронная почта: <a href="mailto:contact@bmksoft.info">contact@bmksoft.info</a></div>
                        </div>
                        <div className={S.typeActivityBox}>
                            <div className={S.typeActivityTitle}>Вид деятельности</div>
                            <div className={S.typeActivityDiv}>
                                <div>Код: 1.01</div>
                                <span>
                                    Проектирование, и (или) обследование, и (или) разработка, и (или) адаптация, и
                                (или) модификация (в том числе локализация, кастомизация, доработка), и (или) обратное
                                проектирование (реверсивный инжиниринг), и (или) модернизация, и (или) обновление, и
                                (или) установка, и (или) интеграция, и (или) настройка, и (или) конфигурирование, и
                                (или) внедрение, и (или) сопровождение, и (или) тестирование, и (или) испытания, и (или)
                                техническая поддержка, и (или) эксплуатация, включая администрирование, а также оказание
                                услуг (в том числе консультационных, услуг по обучению, экспертных услуг и иных) в
                                указанных видах деятельности (далее - проектирование и (или) иная деятельность, а также
                                оказание услуг), в отношении программ для электронных вычислительных машин (далее -
                                программы для ЭВМ), и (или) баз данных (в том числе их обновлений и исправлений), и
                                (или) визуальных пользовательских интерфейсов.
                                </span>
                            </div>
                        </div>
                        <div className={S.typeActivityBox}>
                            <div className={S.typeActivityTitle}>Технологический стек</div>
                            <div className={S.typeActivityDiv}>
                                <div>Backend-разработка:</div>
                                <span>
                                     C#, .NET, Java, PostgreSQL, Swagger, Kubernetes, Jenkins, Jira, Confluence, JDBC, Open API, Spring boot 2, REST API, SOAP API, liquibase.
                                </span>
                            </div>
                            <div className={S.typeActivityDiv}>
                                <div>Frontend-разработка:</div>
                                <span>
                                     ReactJS, Redux-toolkit, TypeScript, SASS, Scss, CSS modules, Jest, Material-UI.
                                </span>
                            </div>
                            <div className={S.typeActivityDiv}>
                                <div>Тестирование:</div>
                                <span>
                                     Zephyr, Postman, PostgreSQL, SoapUI, Jenkins, REST, SOAP.
                                </span>
                            </div>
                            <div className={S.typeActivityDiv}>
                                <div>Аналитика и дизайн:</div>
                                <span>
                                     Jira, Confluence, Draw.io, Figma, BPMN, SCRUM , XSD, XML, UML, Visual Paradigm, Postman, Swagger, Sequence diagram.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};